export class M3StyleCreateRequest {
    m3StyleId:number;
    m3StyleCode:string;


}